import { ProgressSpinner } from "primereact/progressspinner";

export default function ModuleBlockLoading() {
  return (
    <div className="absolute top-0 left-0 w-full h-full flex align-items-center justify-content-center bg-white-alpha-20 z-4">
      <ProgressSpinner style={{ transform: "scale(0.5)" }} strokeWidth="6" />
    </div>
  );
}
